import React from "react";
import {
  CheckBadgeIcon,
  CheckCircleIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
const DocumentTypeIcons = ({ documentType }) => {
  return (
    <div className="w-16 h-12 bg-white border border-gray-300 rounded-md flex items-center justify-center flex-shrink-0">
      {documentType?.toLowerCase() === "rfi" ? (
        <CheckCircleIcon className="h-9 w-9 text-blue-500" />
      ) : (
        <CheckBadgeIcon className="h-9 w-9 text-red-500" />
      )}
    </div>
  );
};

export default DocumentTypeIcons;
